import { XRAY_CONFIGURATION_DEFAULT_EVENTS } from '../interfaces/xrayConfiguration';
import { snakeCase } from 'lodash';

export const isDefaultFacebookConversionApiEventId = (id: string) => {
  return Object.values(XRAY_CONFIGURATION_DEFAULT_EVENTS).includes(id);
};

export const isDefaultFacebookConversionApiEventIdSnakeCase = (id: string) => {
  return Object.values(XRAY_CONFIGURATION_DEFAULT_EVENTS)
    .map(snakeCase)
    .includes(id);
};
